module.exports = __webpack_public_path__ + "img/air.a2fc2297.svg";